module.exports = __webpack_public_path__ + "static/media/TimEmmrich.c91da6c1.jpg";